<template>
  <div>
    <item-select v-model="dd"
                 :disabled="disabled"
                 :options="options" />
  </div>
</template>
<script>
import request from '../../../api/request'
import LibProductItem from '../../../minxin/ProductItem';

export default {
  name: "ProductItemTypeCompany",
  mixins: [LibProductItem],
  data() {
    return {
      options: [],
    }
  },
  props: ['value'],
  created() {
    request.front.post('defines').then(r => {
      for (let k in r.data.insurance_company) {
        this.options.push({
          value: k,
          display: r.data.insurance_company[k]
        })
      }

      this.options.sort((l, r) => {
        return l.display.localeCompare(r.display, "zh");
      })
    })
  }
}
</script>